import { v4 as uuidv4 } from 'uuid';

const halfLives = '0.1, 2, 5, 20, 50, 200';
const regressionWeightCount = 20;

function alphaBook(title: string, market: string, product: string, broker: string) {
  return {
    id: uuidv4(),
    type: 'Single',
    title,
    config: {
      typeId: 'meepmeep_alphabook',
      props: {
        market,
        product,
        broker,
        value_field: 'mid',
      },
    },
  };
}

function laggedReturnEma(
  title: string,
  market: string,
  product: string,
  broker: string,
  instReturns: boolean,
) {
  return {
    id: uuidv4(),
    type: 'Formatter',
    title,
    isPayloadAware: true,
    config: {
      typeId: 'meepmeep_lagged_return_ema',
      props: {
        half_lives: halfLives,
        inst_returns: instReturns,
        spread_cap: '',
      },
      child: alphaBook(`${market} ${product} ${broker}`, market, product, broker),
    },
  };
}

const meepMeepAlphaTemplate = {
  name: 'MeepMeep: TTF DA Implied',
  data: {
    id: uuidv4(),
    type: 'MeepMeep',
    title: 'MeepMeep Strategy',
    isMicrostructure: true,
    isPayloadAware: true,
    config: {
    latency_ms: 35,
      insample_days: 3,
      target_forward_ticks: 25,
      max_volume: 1,
      trade_margin: 0,
      trade_margin_regime: 'static',
      main_market: alphaBook('TTF DA EEX_SPOT', 'TTF', 'DA', 'EEX_SPOT'),
      signal: {
        id: uuidv4(),
        type: 'Regression',
        title: 'Alpha Signal',
        isMicrostructure: true,
        isPayloadAware: true,
        config: {
          model_type: 'ridge',
          weights: Array.from({ length: regressionWeightCount }, () => 0),
          inputs: [
            laggedReturnEma('TTF DA Lagged Returns', 'TTF', 'DA', 'EEX_SPOT', false),
            laggedReturnEma('TTF FM Lagged Returns', 'TTF', 'FM', 'ICE', true),
            laggedReturnEma('THE DA Lagged Returns', 'THE', 'DA', 'EEX_SPOT', true),
          ],
        },
      },
    },
  },
};

export default meepMeepAlphaTemplate;
